import * as Telecom from '@servicetitan/telecom-rtcs-client';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import isValidUser from '../../lib/isValidUser';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';
import { recordAgentLoggedOut } from '../../lib/agentLogoutGuard';
import { statusForAgentLoggedOut } from '../../lib/agentLoginStatus';
import { applyAgentLoginStatus } from '../../lib/applyAgentLoginStatus';

async function handleAgentLoggedOut(event: Telecom.AgentLoggedOutEvent) {
  if (
    !FeatureFlagModule.isEnabled(
      FeatureFlagKeys.featureAgentLoginLogoutStatusSync,
    )
  ) {
    return;
  }

  if (!isValidUser(event.agentId)) {
    return;
  }

  // The current user logs out and back in on reset and status refresh.
  if (event.agentId === serviceState.contactCenterUserId) {
    return;
  }

  log('rtcs:agent:loggedOut:' + event.agentId, event);

  if (!recordAgentLoggedOut(event.agentId, event.timestamp)) {
    return;
  }
  await applyAgentLoginStatus(event.agentId, statusForAgentLoggedOut());
}

export default handleAgentLoggedOut;
